import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#2e7d32',      // forest green
      light: '#60ad5e',
      dark: '#005005',
    },
    secondary: {
      main: '#5d4037',      // earth brown
      light: '#8b6865',
      dark: '#321911',
    },
    background: {
      default: '#f5f5f0',
    },
  },
  components: {
    MuiAppBar: {
      defaultProps: { elevation: 2 },
    },
    MuiChip: {
      styleOverrides: {
        root: { fontWeight: 600 },
      },
    },
  },
});

export default theme;
